import { useMemo, useState } from "react";
import PageIntro from "../../Components/modern/PageIntro";
import PdfPreview, { DocumentActions, usePdfBlobUrl } from "../../Components/modern/PdfPreview";
import { Container, SectionHeading } from "../../Components/modern/UI";
import { newsletterYears, newslettersByYear, sortedNewsletters } from "../../Data/newsletterData";

function IssueActions({ issue }) {
  const { previewUrl } = usePdfBlobUrl(issue.file);
  return <DocumentActions file={issue.file} fileName={issue.fileName} previewUrl={previewUrl} openLabel="View" downloadLabel="Download" className="sn-mt-5" />;
}

export default function Blog() {
  const latestIssue = sortedNewsletters[0];
  const featuredIssue = sortedNewsletters.find((issue) => issue.id === "february-march-2026") || latestIssue;
  const january2026Issue = sortedNewsletters.find((issue) => issue.id === "january-2026") || latestIssue;
  const [selectedIssueId, setSelectedIssueId] = useState(january2026Issue.id);
  const selectedIssue = useMemo(
    () => sortedNewsletters.find((issue) => issue.id === selectedIssueId) || january2026Issue,
    [selectedIssueId, january2026Issue]
  );

  return (
    <>
      <PageIntro eyebrow="Newsletter" title={<>Monthly Suryanirbhar updates and field stories.</>} />

      <section aria-labelledby="sn-featured-newsletter" className="sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-grid sn-gap-8 lg:sn-grid-cols-[360px_1fr] lg:sn-items-start">
            <aside className="sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-6 sn-shadow-soft">
              <SectionHeading eyebrow="Featured issue" id="sn-featured-newsletter">{featuredIssue.displayDate}</SectionHeading>
              <p className="sn-mt-4 sn-text-sm sn-leading-relaxed sn-text-muted">{featuredIssue.title}</p>
              <IssueActions issue={featuredIssue} />
            </aside>

            <div className="sn-min-w-0">
              <PdfPreview file={featuredIssue.file} title={featuredIssue.title} heightClass="sn-h-[min(76vh,820px)]" />
            </div>
          </div>
        </Container>
      </section>

      <section aria-labelledby="sn-newsletter-archive" className="sn-border-t sn-border-line sn-py-12 md:sn-py-16">
        <Container>
          <div className="sn-mb-8 sn-max-w-3xl">
            <SectionHeading eyebrow="Previous issues" id="sn-newsletter-archive">Newsletter archive.</SectionHeading>
          </div>

          <div className="sn-grid sn-gap-8 lg:sn-grid-cols-[360px_1fr]">
            <div className="sn-space-y-6">
              {newsletterYears.map((year) => (
                <section key={year} aria-labelledby={`sn-newsletter-year-${year}`} className="sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-5 sn-shadow-soft">
                  <h3 id={`sn-newsletter-year-${year}`} className="sn-font-display sn-text-2xl sn-text-forest">{year}</h3>
                  <div className="sn-mt-4 sn-space-y-3">
                    {newslettersByYear[year].map((issue) => (
                      <button
                        key={issue.id}
                        type="button"
                        onClick={() => setSelectedIssueId(issue.id)}
                        aria-pressed={selectedIssue.id === issue.id}
                        className={`sn-block sn-w-full sn-rounded sn-border sn-p-4 sn-text-left sn-transition focus-visible:sn-outline focus-visible:sn-outline-2 focus-visible:sn-outline-offset-2 focus-visible:sn-outline-leaf ${selectedIssue.id === issue.id ? "sn-border-forest sn-bg-sage" : "sn-border-line sn-bg-cream hover:sn-border-forest/30"}`}
                      >
                        <span className="sn-block sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.16em] sn-text-leaf">{issue.month}</span>
                        <span className="sn-mt-1 sn-block sn-font-display sn-text-lg sn-leading-tight sn-text-forest">{issue.title}</span>
                      </button>
                    ))}
                  </div>
                </section>
              ))}
            </div>

            <article className="sn-min-w-0 sn-rounded-card sn-border sn-border-line sn-bg-white sn-p-4 sn-shadow-soft md:sn-p-6">
              <div className="sn-mb-5 sn-flex sn-flex-col sn-gap-4 md:sn-flex-row md:sn-items-start md:sn-justify-between">
                <div>
                  <p className="sn-text-[11px] sn-font-bold sn-uppercase sn-tracking-[0.18em] sn-text-leaf">Selected issue</p>
                  <h3 className="sn-mt-2 sn-font-display sn-text-3xl sn-leading-tight sn-text-forest">{selectedIssue.displayDate}</h3>
                  <p className="sn-mt-2 sn-text-sm sn-text-muted">{selectedIssue.title}</p>
                </div>
                <IssueActions issue={selectedIssue} />
              </div>
              <div className="sn-hidden md:sn-block">
                <PdfPreview file={selectedIssue.file} title={selectedIssue.title} heightClass="sn-h-[min(72vh,760px)]" />
              </div>
              <div className="sn-rounded sn-border sn-border-line sn-bg-cream sn-p-5 sn-text-sm sn-leading-relaxed sn-text-muted md:sn-hidden">
                Use View to open the selected newsletter for reading on this device, or Download to save a copy.
              </div>
            </article>
          </div>
        </Container>
      </section>
    </>
  );
}
